var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full",staticStyle:{"page-break-before":"always"}},[_c('app-separator',{attrs:{"tag":"h1","label":_vm.$t('project.follow.meetings.description')}}),_c('div',{staticClass:"text-xs border"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.meeting.description)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }